import { css } from '@emotion/react';
import { type FC } from 'react';
import { ChatButtonComponent } from '~/map/mapToolControls/chatButton/chatButton.component';
import {
  GOOGLE_LOGO_SAFE_BOTTOM_OFFSET_PX, GOOGLE_LOGO_SAFE_LEFT_OFFSET_PX,
} from '~/map/mapToolControls/mapOffsets.constants';
import { OverlappingUIPanelContainer } from '~/map/mapToolControls/menuItems/overlappingUI/overlappingUIPanel.container';
import { MOBILE_TOOL_PANEL_OPEN_LEFT_CLUSTER_BOTTOM_SHIFT_PX } from '~/map/mapToolControls/mobileToolPanelOpenOffsets.constants';
import { type StreetViewState } from '~/store/frontendState/mapTools/streetView/streetView.state';
import { type MapSettingsPublicMapSettingsState } from '~/store/mapSettings/publicMapSettings/mapSettingsPublicMapSettings.state';
import { MapMarkersVisibilityToggleContainer } from '../menuItems/mapMarkersVisibilityToggle.container';
import { MapToolsMyLocationMenuItem } from '../menuItems/roundToolsButtonMenuItem/mapToolsMyLocationMenuItem.container';

// cannot cover the Google logo because of Google Maps TOS!
const BOTTOM_MARGIN = GOOGLE_LOGO_SAFE_BOTTOM_OFFSET_PX;
const FRAME_OFFSET_PX = 10;
export const LEFT_SIDE_TOOLS_SAFE_OFFSET_PX = FRAME_OFFSET_PX + GOOGLE_LOGO_SAFE_LEFT_OFFSET_PX;

const leftSideMapToolsStyle = ({ isMobileToolPanelOpen, transitionDurationMs }: { isMobileToolPanelOpen: boolean; transitionDurationMs: number }) => {
  const bottom = isMobileToolPanelOpen ? MOBILE_TOOL_PANEL_OPEN_LEFT_CLUSTER_BOTTOM_SHIFT_PX : BOTTOM_MARGIN;

  return css({
    position: 'absolute',
    bottom,
    left: FRAME_OFFSET_PX,
    display: 'flex',
    flexDirection: 'column-reverse',
    gap: '8px',
    zIndex: 1,
    height: `calc(100% - ${bottom + FRAME_OFFSET_PX}px)`,
    pointerEvents: 'none',
    transition: `bottom ${transitionDurationMs}ms ease-in-out, height ${transitionDurationMs}ms ease-in-out`,

    '& > *': {
      pointerEvents: 'auto',
    },
  });
};

type LeftSideMapToolsComponentProps = Readonly<{
  isMapPresentational: boolean;
  isMobileScreen: boolean;
  isMarkerVisibilityVisible?: boolean;
  isMobileToolPanelOpen: boolean;
  publicMapSettings?: MapSettingsPublicMapSettingsState;
  streetView: StreetViewState;
  transitionDurationMs: number;
}>;

export const LeftSideMapToolsComponent: FC<LeftSideMapToolsComponentProps> = (props) => {
  const showLocationMenu = props.isMobileScreen &&
    (!props.isMapPresentational || props.publicMapSettings?.showMyLocation);

  return (
    <div css={leftSideMapToolsStyle({ isMobileToolPanelOpen: props.isMobileToolPanelOpen, transitionDurationMs: props.transitionDurationMs })}>
      {!props.isMapPresentational && <ChatButtonComponent />}
      {!props.streetView.active && (
        <>
          {props.isMarkerVisibilityVisible && <MapMarkersVisibilityToggleContainer />}
          {showLocationMenu && <MapToolsMyLocationMenuItem />}
          <OverlappingUIPanelContainer />
        </>
      )}
    </div>
  );

};
